import React, { useEffect, useState } from "react";
import * as Style from "./styledComponents/StartMessage";
import ExecutorTrusteeStart from "../assets/images/DeathModuleNew/People-2.png";
import clockCircle from "../assets/images/DeathModuleNew/clock-circle.svg";

import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import setting from "../assets/SVGs/setting.svg";
import { Modal, Select, Col } from "antd";
import { Messages, HiddenMessages, TrusteeMessages, HiddenModalMessages } from "./MessageConstant";
import Loader from "../components/styled-components/loader/loader";

import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import Timer from "./Timer";
import { Link } from "react-router-dom";
import { Row } from "antd";
import swal from "sweetalert";
import moment from "moment";
import axios from "axios";
import { ToolTipCreator } from "../helpers/ToolTipCreator";
const { Option } = Select;

export const StartMessage = (props) => {
  const [hiddenMessage, setHiddenMessage] = useState(HiddenModalMessages);
  const [clientStatus, setClientStatus] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [apiTime, setApiTime] = useState("");
  const [newRole, setNewRole] = useState("");
  const [timer, setTimer] = useState("");
  const [timerState, setTimerState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [fileUploadAspects, setFileUploadAspects] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accessModal, setaccessModal] = useState(false);
  const [uploaded, setUploaded] = useState({});
  const [show, setShow] = useState(false);
  const [tooltipModal, setTooltipModal] = useState(false);
  const [helpModal, setHelpModal] = useState(false);

  const [dropdown, setDropdown] = useState(false);

  const [messageModal, setMessageModal] = useState(false);
  const [welcomeMessageModal, setwelcomeMessageModal] = useState(false);

  console.log("props in messages", props.role);
  const filesList = [
    { id: 1, fileName: "file name234567890-" },
    { id: 2, fileName: "file name234567891-" },
    { id: 3, fileName: "file name234567892-" },
  ];
  const handleClick = (id) => {
    console.log("id on click", id);
    hiddenMessage.map((item) => {
      if (item.id === id) {
        if (item.show === true) {
          item.show = false;
          // setMessageModal(false);
        } else {
          item.show = true;
          showMessageModal();
          console.log("here in hidden false", id, item.id);
          // setMessageModal(true);
        }

        setShow(!show);
      } else {
        item.show = false;
      }
    });
    setHiddenMessage(hiddenMessage);
    console.log("hiddenMessage", hiddenMessage);
  };

  useEffect(() => {
    getClientStatus();
  }, []);

  const getClientStatus = async () => {
    const ID = localStorage.getItem("accessId");

    if ((props.role === "protrustee" || props.role === "trustee") && ID === null) {
      console.log("here to show modal");
      showAccessModal();
    }
    try {
      (async () => {
        // this.setState({ isLoading: true })
        // this.props.handleLoader();
        setLoading(true);
        const ID = localStorage.getItem("accessId");
        const role = localStorage.getItem("role") != "undefined" && JSON.parse(localStorage.getItem("role"));
        console.log("role death", role);
        const data = await DEATH_API.getDeathStatus(ID);
        console.log("data in death status for client", data);
        if (data && data.clientStatus) {
          console.log("data setting", data);
          setClientStatus(data);
          setTimer(data.clientStatus.deathStatusRevertTime);
          // this.setState({ DeathStatus: data.clientStatus.deathStatus });
          // this.setState({ TrusteeStatus: data.clientStatus.deathStatus });
          // this.setState({ clientName: data.clientName });
          // this.setState({ trusteeName: data.trusteeName });
          // this.setState({ TrusteeStatus: data.clientStatus.deathStatus });
          // this.setState({ timer: data.clientStatus.deathStatusRevertTime });

          if (props.role == "trustee" || props.role == "protrustee") {
            console.log("here in trusteee");
            localStorage.setItem("role", JSON.stringify(data.clientStatus.roleName));
            console.log("data.clientStatus.roleName", data.clientStatus.roleName);
            setTimer(data.clientStatus.deathStatusRevertTime);
            setNewRole(data.clientStatus.roleName);
            // this.setState({ NewRole: data.clientStatus.roleName });
            // this.setState({ timer: data.clientStatus.deathStatusRevertTime });
          }
          if (data.clientStatus.deathStatusDate !== null) {
            setStartTime(data.clientStatus.deathStatusDate);
            // this.setState({
            //   StartTime: data.clientStatus.deathStatusDate,
            // });
          }
          setApiTime(data.clientStatus.deathStatusRevertTime);
          // this.setState({
          //   ApiTime: data.clientStatus.deathStatusRevertTime,
          // });
        }

        let dataFile = await DEATH_API.getAdvanceHealth(ID);
        console.log("dataFile", dataFile);
        if (dataFile && dataFile.data) {
          setFileUpload(dataFile.data);
        }

        setLoading(false);
        // this.props.handleLoader();
        // this.setState({ isLoading: false })
      })();
    } catch (error) {
      // this.props.handleLoader();
      setLoading(false);
      console.group(error);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
    // this.setState({
    //   isModalOpen: true,
    // });
  };

  const showAccessModal = () => {
    setaccessModal(true);
    // this.setState({
    //   AccessModal: true,
    // });
  };

  const handleAccessCancel = () => {
    setaccessModal(false);
  };

  const getFile = async () => {
    const ID = localStorage.getItem("accessId");
    setLoading(true);
    let dataFile = await DEATH_API.getAdvanceHealth(ID);
    if (dataFile && dataFile.data) {
      setFileUpload(dataFile.data);
    }

    setLoading(false);
  };
  const activateDeath = async () => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to Activate this?",
      dangerMode: true,
      buttons: ["No, don't activate!", "Yes, Activate it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        console.log("inside confirm status");
        try {
          // that.props.handleLoader();
          setLoading(true);
          const ID = localStorage.getItem("accessId");

          let api_res = await DEATH_API.confirmDeath(ID);
          // that.props.handleLoader();
          setLoading(false);
          // that.props.handleLoader();
          setLoading(true);
          const data = await DEATH_API.getDeathStatus(ID);
          console.log("data in death status", data);
          if (data && data.clientStatus) {
            setClientStatus(data);

            if (props.role == "trustee" || props.role == "protrustee") {
              localStorage.setItem("role", JSON.stringify(data.clientStatus.roleName));
              console.log("data.clientStatus.roleName", data.clientStatus.roleName);
              setNewRole(data.clientStatus.roleName);
            }
            if (data.clientStatus.deathStatusDate !== null) {
              setStartTime(data.clientStatus.deathStatusDate);
            }
            setApiTime(data.clientStatus.deathStatusRevertTime);
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error");
        }
        setTimeout(() => {
          setLoading(true);
          swal("Activated!", "Access will be given to you with in specified time :)", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", " You have No Access to If I Die Module :)", "error");
      }
    });
  };
  const cancelDeathClient = async () => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to cancel this?",
      dangerMode: true,
      buttons: ["No!", "Yes, cancel it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        console.log("inside confirm status");
        try {
          // that.props.handleLoader();
          setLoading(true);
          const ID = localStorage.getItem("accessId");
          let api_res = await DEATH_API.revertDeath(ID);
          if (api_res && api_res.status === 200) {
            const data = await DEATH_API.getDeathStatus(ID);
            if (data && data.clientStatus) {
              setClientStatus(data);

              if (props.role == "trustee" || props.role == "protrustee") {
                localStorage.setItem("role", JSON.stringify(data.clientStatus.roleName));
                console.log("data.clientStatus.roleName", data.clientStatus.roleName);
                setNewRole(data.clientStatus.roleName);
                // that.setState({
                //   NewRole: data.clientStatus.roleName,
                // });
              }
              if (data.clientStatus.deathStatusDate !== null) {
                setStartTime(data.clientStatus.deathStatusDate);
                // that.setState({
                //   StartTime:
                //     data.clientStatus.deathStatusDate,
                // });
              }
              setApiTime(data.clientStatus.deathStatusRevertTime);
              setTimeout(() => {
                setLoading(true);
                swal("Canceled!", "Trusted Individual Access Canceled.", "success");
                setLoading(false);
              }, 0);
            }
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          throw new Error(error);
        }
      } else {
        swal("Cancelled", "Access will be given to trusted with in specified time :)", "error");
      }
    });
  };
  const cancelDeathtrustee = async () => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to cancel this?",
      dangerMode: true,
      buttons: ["No!", "Yes, cancel it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        console.log("inside confirm status");
        try {
          setLoading(true);
          const ID = localStorage.getItem("accessId");
          let api_res = await DEATH_API.revertDeath(ID);

          if (api_res && api_res.status === 200) {
            const data = await DEATH_API.getDeathStatus(ID);
            console.log("data in death status", data);
            if (data && data.clientStatus) {
              setClientStatus(data);
              if (props.role == "trustee" || props.role == "protrustee") {
                localStorage.setItem("role", JSON.stringify(data.clientStatus.roleName));
                console.log("data.clientStatus.roleName", data.clientStatus.roleName);
                setNewRole(data.clientStatus.roleName);
              }
              if (data.clientStatus.deathStatusDate !== null) {
                setStartTime(data.clientStatus.deathStatusDate);
              }
              setApiTime(data.clientStatus.deathStatusRevertTime);
              setTimeout(() => {
                setLoading(true);
                swal("Canceled!", "Trusted Individual Access Canceled.", "success");
                setLoading(false);
              }, 0);
            }
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          throw new Error(error);
        }
      } else {
        swal("Cancelled", "Access will be given to trusted with in specified time :)", "error");
      }
    });
  };
  const handleOk = async () => {
    setIsModalOpen(false);
    // this.setState({
    //   isModalOpen: false,
    // });

    try {
      // this.props.handleLoader();
      setLoading(true);
      const res = await DEATH_API.setRevertTime(timer);
      console.log("res.....", res);
      setLoading(false);
      // this.props.handleLoader();

      // this.props.handleLoader();
      // const data = await DEATH_API.getDeathStatus();
      // console.log("data in death status", data);
      // if (data) {
      //   this.setState({ DeathStatus: data.clientStatus })
      // }
      // this.props.handleLoader();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    console.log("timer>>>", timer);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    // this.setState({
    //   isModalOpen: false,
    // });
  };
  const handleRemoveFile = async () => {
    setLoading(true);
    console.log("remove");
    let api_res = await DEATH_API.updateAdvanceHealth({
      advanceHealthCareDirectiveDocument: "",
      advanceHealthCareDirectiveFileName: "",
      advanceHealthCareDirectiveDate: null,
    });
    console.log("res", api_res);
    const ID = localStorage.getItem("accessId");

    let dataFile = await DEATH_API.getAdvanceHealth(ID);
    if (dataFile && dataFile.data) {
      setFileUpload(dataFile.data);
    }

    setLoading(false);
    getFile();
  };
  const handleUploadFile = async (fileUrl, fileName) => {
    const ID = localStorage.getItem("accessId");
    setLoading(true);
    console.log("uploaded", fileUrl, fileName);
    if (fileUrl) {
      let api_res = await DEATH_API.addAdvanceHealth({
        advanceHealthCareDirectiveDocument: fileUrl,
        advanceHealthCareDirectiveFileName: fileName,
        advanceHealthCareDirectiveDate: new Date(),
      });

      let dataFile = await DEATH_API.getAdvanceHealth(ID);
      if (dataFile && dataFile.data) {
        setFileUpload(dataFile.data);
      }

      setLoading(false);
      console.log("api_res", api_res);
      // setUploaded(uploaded);
    } else {
      setLoading(false);
    }
  };

  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };

  const showHelpModal = () => {
    setHelpModal(true);
  };

  const handleHelpCancel = () => {
    setHelpModal(false);
  };

  const showMessageModal = () => {
    setMessageModal(true);
  };

  const handleMessageCancel = () => {
    setMessageModal(false);
  };

  const showWelcomeMessageModal = () => {
    setwelcomeMessageModal(true);
    handleMessageCancel();
  };

  const handleWelcomeMessageCancel = () => {
    console.log("message modal close");
    setwelcomeMessageModal(false);
  };

  return (
    <div>
      <Style.MainHeading style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          {/* <Style.HeaderImg
            src={ExecutorTrusteeStart}
            alt="ExecutorTrusteeStart"
          ></Style.HeaderImg> */}
          <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
            Start Here{" "}
            <ToolTipCreator name={"Death_Start_Here"}/>
          </div>
          {/* <Style.HelpIcon
            src={helpIcon}
            alt="helpicon"
            onClick={() => {
              showTooltipModal();
            }}
          ></Style.HelpIcon> */}
        </div>
        <div>
          {props.role !== "trustee" && props.role !== "protrustee" ? (
            <React.Fragment>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <img
                  style={{ marginBottom: "5px", cursor: "pointer" }}
                  onClick={async () => {
                    showModal();
                  }}
                  src={clockCircle}
                  height={35}
                  width={35}
                ></img>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}
        </div>
      </Style.MainHeading>

      {/* trustee and protrustee work in for client death status*/}
      <Modal centered visible={helpModal} footer={null} onCancel={handleHelpCancel}>
        <Style.ModalTitle> Advanced Health Care Directives</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              Advanced Health Care Directives (ACHD) should be created by every adult who has opinions on how
              their body should be treated in a medical emergency. Each state is different, and some health
              insurance companies offer their ACHD form for free. Estate professionals often include the ACHD
              in their services when creating a Trust. Once you have completed an ACHD you need to make it
              accessible to people you care about, and to those that care about you. The Death Legacy module
              made this document highly accessible within our program, should it ever be necessary to access
              by anyone you authorize, anywhere in the world, with the internet and these websites-{" "}
              <a style={{ color: "#2A3DA3" }} href="https://ifidie.com/" target="blank">
                {" "}
                iFiDiE.com{" "}
              </a>{" "}
              or
              <a style={{ color: "#2A3DA3" }} href="https://whenidie.com/" target="blank">
                {" "}
                WheniDie.com{" "}
              </a>
              .
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>
      <Modal centered visible={tooltipModal} footer={null} onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Asset Planet Message</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              This module is designed to help you organize your critical end-of-life information, making things easier for your loved ones during a difficult time. It serves as a central, secure place to outline instructions and consolidate the details your family will need to ensure your final wishes are understood and respected.
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>
      <Modal
        title={<span style={{ textAlign: "center", display: "block" }}>Delegate Access Modal</span>}
        visible={accessModal}
        footer={null}
        closable={false}
      >
        <div style={{}}>
          {/* <div style={{padding:"50px",background:"black",overflow:"hidden"}}>hellow</div> */}
          <div className="">
            <h2 className="otp-heading">Please Select Client before Accessing this Module</h2>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Link to="/delgateAccess">
                <Style.SaveButton>Go to Delegate Access</Style.SaveButton>
              </Link>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        // title={"Settings"}
        visible={isModalOpen}
        footer={null}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
      >
        <div style={{}}>
          {/* <div style={{padding:"50px",background:"black",overflow:"hidden"}}>hellow</div> */}
          <div className="">
            <Style.ModalDetails>
              {" "}
              This module allows a Trusted Individual to gain access to your information in the event of your
              death...but only if you have died! If your Trusted Individual logs in and clicks the "
              {localStorage.getItem("User") ? localStorage.getItem("User") : ""} has died, start process"
              button, a timer will start allowing you to stop the process. You can select the duration of that
              timer here.
            </Style.ModalDetails>
            <div>
              <div>
                <label
                  style={{
                    color: "#7D8FB3",
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontWeight: "700",
                  }}
                >
                  Set Timer for Trusted Individual for full access:
                </label>
                <Select
                  showSearch
                  placeholder="-Select-"
                  defaultValue={timer}
                  listHeight="120"
                  // style={{height:"2rem"}}
                  onChange={(value) => {
                    setTimer(value);
                    // this.setState({
                    //   timer: value,
                    // });
                  }}
                >
                  <Option value="4">4 hours</Option>
                  <Option value="8">8 hours</Option>
                  <Option value="12">12 hours</Option>
                  <Option value="24">24 hours</Option>
                  <Option value="48">48 hours</Option>
                </Select>
              </div>
            </div>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton
              id="stop"
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel
            </Style.CancelButton>
            <Style.SaveButton id="stop" onClick={handleOk}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </div>
      </Modal>
      {clientStatus &&
      clientStatus.clientStatus.deathStatus === "PARTIAL_DEATH" &&
      props.role != "trustee" &&
      props.role != "protrustee" ? (
        <div className="info-form-block" style={{ marginTop: "30px" }}>
          <Row gutter={16}>
            <Col span={24}>
              <h3 className="text-center font-weight-bold">
                {clientStatus.trusteeName && clientStatus.trusteeName} has activated your If I Die module.
              </h3>
              <h4 className="text-center font-weight-bold">Time remaining until they have full access:</h4>
            </Col>
            <Col span={24}>
              <h4 className="text-center font-weight-bold">
                {apiTime && startTime && (
                  <Timer
                    timerState={
                      (time) => setTimerState(time)
                      // this.setState({
                      //   timerState: time,
                      // })
                    }
                    Time={apiTime}
                    startTime={startTime}
                  />
                )}
              </h4>
              <h4 className="text-center font-weight-bold">
                {timerState &&
                  timerState <= 0 &&
                  `Trusted Individuals now have access to your's information.`}
              </h4>
              <div className="text-center" style={{ display: "flex", justifyContent: "center" }}>
                {timerState && timerState >= 0 && (
                  <Style.SaveButton
                    onClick={() => {
                      cancelDeathClient();
                    }}
                  >
                    <span className="custom-footer-text">Cancel Timer</span>
                  </Style.SaveButton>
                )}
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        ""
      )}
      {clientStatus && clientStatus.clientStatus.deathStatus === "ALIVE" && props.role == "trustee" ? (
        <div className="info-form-block" style={{ marginTop: "30px" }}>
          <Row gutter={16}>
            <Col span={24}>
              <h3 className="text-center font-weight-bold">
                {clientStatus.clientName && clientStatus.clientName} has Passed Away.
              </h3>
              <h4 className="text-center font-weight-bold ">
                Click This Button to Activate If I Die module:
              </h4>
              {apiTime && (
                <h4 className="text-center font-weight-bold">
                  You Will have access in hours: {apiTime && apiTime}
                </h4>
              )}
            </Col>
            <Col span={24}>
              <h4 className="text-center font-weight-bold mb-4"></h4>
              <div className="text-center" style={{ display: "flex", justifyContent: "center" }}>
                <Style.SaveButton
                  // disabled={true}
                  onClick={async () => {
                    activateDeath();
                  }}
                >
                  <span className="custom-footer-text">Activate</span>
                </Style.SaveButton>
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        ""
      )}
      {clientStatus &&
      clientStatus.clientStatus.deathStatus === "PARTIAL_DEATH" &&
      props.role == "trustee" ? (
        <div className="info-form-block" style={{ marginTop: "30px" }}>
          <Row gutter={16}>
            <Col span={24}>
              <h3 className="text-center font-weight-bold">
                {clientStatus.clientName && clientStatus.clientName} has Passed Away.
              </h3>

              {apiTime && (
                <h4 className="text-center font-weight-bold">
                  You Will have access in hours: {apiTime && apiTime}
                </h4>
              )}
            </Col>
            <Col span={24}>
              <h4 className="text-center font-weight-bold mb-4">
                {apiTime && startTime && props.role === "trustee" && (
                  <Timer
                    timerState={
                      (time) => setTimerState(time)
                      // this.setState({
                      //   timerState: time,
                      // })
                    }
                    Time={apiTime}
                    startTime={startTime}
                  />
                )}
              </h4>
              <h4 className="text-center font-weight-bold mb-4">
                {" "}
                {timerState &&
                  timerState <= 0 &&
                  `You and the other Trusted Individuals now have access to ${this.state.clientName}'s information.`}
              </h4>
              <div className="text-center" style={{ display: "flex", justifyContent: "center" }}>
                {/* {this.state.timerState} */}
                {timerState && timerState >= 0 && (
                  <Style.SaveButton
                    onClick={() => {
                      // var that = this;
                      cancelDeathtrustee();
                    }}
                  >
                    <span className="custom-footer-text">Cancel Activation</span>
                  </Style.SaveButton>
                )}
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        <React.Fragment></React.Fragment>
      )}

      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>
            <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
              Upload Advance HealthCare Directives
              <ToolTipCreator name={"Death_Advance_Healthcare_Directives"}/>
            </div>
            {/* <Style.HelpIcon
              src={helpIcon}
              alt="helpicon"
              onClick={() => {
                showHelpModal();
              }}
            ></Style.HelpIcon> */}
          </Style.Title>
          {props.role !== "protrustee" && props.role !== "trustee" && (
            <div>
              <input
                type="file"
                id="upload"
                hidden
                onChange={async (event) => {
                  const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
                  console.log("fileSize in mb", fileSize);
                  let fileName = event.target.files[0].name;
                  let uploadFile = event.target.files[0];
                  const formData = new FormData();
                  formData.append("file", uploadFile);
                  if (uploadFile) {
                    const name = uploadFile.name;
                    const lastDot = name.lastIndexOf(".");
                    const fileName = name.substring(0, lastDot);
                    const ext = name.substring(lastDot + 1);
                    setLoading(true);
                    const resdata = await MODULE_API.uploadFile({
                      fileExt: ext,
                      contentType: uploadFile.type,
                    });
                    const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
                      headers: { "Content-type": uploadFile.type },
                    });
                    const res = resdata.uploadUrl.split("?")[0];
                    setLoading(false);
                    handleUploadFile(res, fileName);
                  }
                }}
                accept="image/jpeg, .pdf, .xlsx, .doc"
              />
              <Style.Button
                for="upload"
                onClick={() => {
                  setDropdown(false);
                }}
              >
                +
              </Style.Button>
              {/*<Style.Button>+</Style.Button> */}
            </div>
          )}
        </Style.HealthCardHeader>
        <Style.FileHeader>
          <Style.FileTitle style={{ display: "flex" }}>
            <a
              style={{ color: "#7d8fb3" }}
              href={fileUpload && fileUpload.advanceHealthCareDirectiveDocument}
              target="blank"
            >
              {" "}
              {fileUpload && fileUpload.advanceHealthCareDirectiveFileName
                ? fileUpload.advanceHealthCareDirectiveFileName
                : ""}{" "}
            </a>
            <div style={{ color: "#7d8fb3", marginLeft: "2rem" }}>
              {" "}
              {fileUpload &&
                fileUpload.advanceHealthCareDirectiveDate &&
                moment(fileUpload.advanceHealthCareDirectiveDate).format("MM-DD-YYYY")}{" "}
            </div>
          </Style.FileTitle>
          {fileUpload && fileUpload.advanceHealthCareDirectiveDocument && (
            <React.Fragment>
              <img
                style={{ cursor: "pointer", marginLeft: "8px" }}
                src={SeeMore}
                alt="seemore"
                onClick={() => {
                  setDropdown(!dropdown);
                  // handleRemoveFile();
                }}
              ></img>
              {dropdown && (
                <>
                  <div
                    onClick={() => {
                      setDropdown(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}
                  ></div>

                  <div
                    className="dropdown"
                    style={{
                      marginTop: "1rem",
                      width: "230px",
                      zIndex: "9999",
                    }}
                  >
                    <ul
                      className="dropdownul"
                      style={{
                        fontSize: "12px",
                        fontFamily: "Poppins",
                        width: "230px",
                      }}
                    >
                      {props.role !== "protrustee" && props.role !== "trustee" && (
                        <li
                          className="liHover"
                          onClick={async () => {
                            handleRemoveFile();
                            setDropdown(false);
                          }}
                        >
                          Delete
                        </li>
                      )}
                      <li
                        className="liHover"
                        onClick={async () => {
                          setDropdown(false);
                        }}
                      >
                        <a
                          // style={{ color: "#4D4F5C", width: "230px" }}
                          href={fileUpload.advanceHealthCareDirectiveDocument}
                          target="blank"
                        >
                          {" "}
                          <div style={{ width: "230px" }}>{fileUpload && "View"} </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </React.Fragment>
          )}
        </Style.FileHeader>
        {/*filesList.map((item, index) => (
          <Style.FileHeader key={index}>
            <Style.FileTitle style={{}}>{item.fileName}</Style.FileTitle>
          </Style.FileHeader>
        )) */}
      </Style.HealthCard>

      <Style.MessageCard>
        <Style.Title style={{}}>Asset Planet Message</Style.Title>

        {props.role !== "protrustee" && props.role !== "trustee" ? (
          <React.Fragment>
            {/*   <div style={{ marginTop: "1rem" }}>
              {Messages.map((item, index) => (
                <Style.Messages key={index}>{item.message}</Style.Messages>
              ))}
            </div>*/}
            <div style={{ marginTop: "2rem" }}>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {hiddenMessage.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      width: "30%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Style.MessageBox
                      onClick={() => {
                        if (item.title === "More in our Knowledge Base") {
                          window.open(item.message, "blank");
                        } else {
                          handleClick(item.id);
                        }
                      }}
                    >
                      <div style={{ width: "30%" }}>
                        <img
                          style={{ height: "50px", width: "50px" }}
                          src={item.image}
                          alt={item.title}
                        ></img>
                      </div>
                      <Style.MessageBoxTitle
                      // onClick={() => {
                      //   handleClick(item.id);
                      // }}
                      >
                        {item.title}
                      </Style.MessageBoxTitle>
                    </Style.MessageBox>
                    {item.show && item.message && messageModal && (
                      <Modal centered visible={messageModal} footer={null} onCancel={handleMessageCancel}>
                        <Style.ModalTitle> {item.title}</Style.ModalTitle>
                        <div style={{}}>
                          <div className="">
                            <Style.ModalDetails>
                              {item.title === "See welcome message for trusted Individual.." && (
                                <a
                                  style={{ color: "#2A3DA3" }}
                                  onClick={() => {
                                    showWelcomeMessageModal();
                                  }}
                                >
                                  {" "}
                                  Click Here{" "}
                                </a>
                              )}{" "}
                              {item.message}
                            </Style.ModalDetails>
                          </div>
                        </div>
                      </Modal>
                    )}
                    {item.title === "See welcome message for trusted Individual.." && welcomeMessageModal && (
                      <Modal
                        centered
                        visible={welcomeMessageModal}
                        footer={null}
                        onCancel={handleWelcomeMessageCancel}
                      >
                        <Style.ModalTitle> Welcome Message</Style.ModalTitle>
                        <div style={{}}>
                          <div className="">
                            <Style.ModalDetails>
                              <p>
                                On behalf of the software team behind the
                                <a style={{ color: "#2A3DA3" }} href="https://whenidie.com/" target="blank">
                                  {" "}
                                  WheniDie.com{" "}
                                </a>{" "}
                                program, we extend our heartfelt sympathy for the loss you are experiencing.
                                Our goal was to work with the Plan Creator to reduce the chaos that often
                                surrounds the death of someone. Your friend or loved one cared greatly about
                                their positive legacy and wanted to make this as easy for you as possible.
                                <br />
                                <br />
                                Now that a Trusted Individual has triggered the program, it is locked, and you
                                have no worries about clicking on the wrong item or concerns about
                                accidentally deleting important information. The Plan Creator completed a
                                checklist that you can now view. Benefits to make this process easier include
                                ready-to-send email messages, important documents, contacts tagged for team
                                support, and many other features. You do not need to be a tech expert, as the
                                process is linear and straightforward. Don't worry if you need help
                                understanding something; each page has help icons to guide you. No stress if
                                you can't find the answer on your own, as the Asset Planet team is ready to
                                assist by using our Contact-Us email.
                                <br />
                              </p>
                            </Style.ModalDetails>
                          </div>
                        </div>
                      </Modal>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div style={{ marginTop: "1rem" }}>
              <Style.TrusteeMessages>
                On behalf of the software team behind the{" "}
                <a style={{ color: "#2A3DA3" }} href="https://whenidie.com/" target="blank">
                  {" "}
                  WheniDie.com{" "}
                </a>{" "}
                program, we extend our heartfelt sympathy for the loss you are experiencing. Our goal was to
                work with the Plan Creator to reduce the chaos that often surrounds the death of someone. Your
                friend or loved one cared greatly about their positive legacy and wanted to make this as easy
                for you as possible.
              </Style.TrusteeMessages>
            </div>
            <div style={{ marginTop: "1rem" }}>
              {TrusteeMessages.map((item, index) => (
                <Style.TrusteeMessages key={index}>{item.message}</Style.TrusteeMessages>
              ))}
            </div>
          </React.Fragment>
        )}
      </Style.MessageCard>
      <Loader isLoading={loading} />
    </div>
  );
};
